/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespSimilarItemsFooter_user = {
    readonly " $fragmentRefs": FragmentRefs<"PdpRespComplementaryItemsGrid_user" | "PdpRespSimilarItemsGrid_user">;
    readonly " $refType": "PdpRespSimilarItemsFooter_user";
};
export type PdpRespSimilarItemsFooter_user$data = PdpRespSimilarItemsFooter_user;
export type PdpRespSimilarItemsFooter_user$key = {
    readonly " $data"?: PdpRespSimilarItemsFooter_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSimilarItemsFooter_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespSimilarItemsFooter_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespComplementaryItemsGrid_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSimilarItemsGrid_user",
      "args": null
    }
  ]
};
(node as any).hash = '150c38bc572db4f377eda689032617d6';
export default node;
